import React from "react";
import { LockIcon, ShieldCheckIcon, SmartphoneIcon } from "lucide-react";
import { educationalDisclaimer } from "./data";
export function Footer() {
  return <footer className="w-full border-t border-[#eef2f6] bg-white px-5 py-10 sm:px-8" data-id="element-75" data-mp="3gh3qydnq44em">
      <div className="mx-auto flex max-w-3xl flex-col items-center gap-5 text-center" data-id="element-76" data-mp="32lrk57wamnhc">
        <p className="font-serif-display text-lg text-[var(--ink)]" data-id="element-77" data-mp="36pzebklisvmy">
          Pequeños Pasos, Grandes Logros™
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-[var(--muted)]" data-id="element-78" data-mp="3ud7gvurkdqla">
          <span className="flex items-center gap-1.5" data-id="element-79" data-mp="3lec768pb9yd8">
            <LockIcon className="h-4 w-4 text-[var(--accent)]" aria-hidden data-id="element-80" data-mp="3ldu3ws48ejvt" /> Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-81" data-mp="3qblw7n8sg80j">
            <ShieldCheckIcon className="h-4 w-4 text-[var(--accent)]" aria-hidden data-id="element-82" data-mp="29ynjtg85axbw" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-83" data-mp="2ezba1zojva52">
            <SmartphoneIcon className="h-4 w-4 text-[var(--accent)]" aria-hidden data-id="element-84" data-mp="3l9k65dxrvpdt" /> Celular, tablet y PC
          </span>
        </div>
        <p className="max-w-2xl text-[11px] leading-relaxed text-[#8b98a5]" data-id="element-85" data-mp="3gb8xv7n4lmxp">
          {educationalDisclaimer}
        </p>
        <p className="text-xs text-[var(--muted)]" data-id="element-86" data-mp="3v9b11gq8w6ef">
          © {new Date().getFullYear()} Pequeños Pasos, Grandes Logros. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}